/// <reference types="vite/client" />
var env;
var HUB_API_URL = 'https://api-proxy.infldev.com';
var STREAM_IO_API_KEY = 'hrm4eqfpkhe6'; // In vite mode, process.env.NODE_ENV exists but process is undefined
// In nextJs mode, 'process.env.TEST' is text replaced to whatever the value is in env variables and process is defined

if (typeof process !== 'undefined') {
  if (process.env.NEXT_PUBLIC_HUB_API_URL) HUB_API_URL = process.env.NEXT_PUBLIC_HUB_API_URL;
  if (process.env.NEXT_PUBLIC_STREAM_IO_API_KEY) STREAM_IO_API_KEY = process.env.NEXT_PUBLIC_STREAM_IO_API_KEY;
} else if (import.meta !== undefined) {
  env = import.meta.env;
  if (env.VITE_PUBLIC_HUB_API_URL) HUB_API_URL = env.VITE_PUBLIC_HUB_API_URL;
  if (env.VITE_PUBLIC_STREAM_IO_API_KEY) STREAM_IO_API_KEY = env.VITE_PUBLIC_STREAM_IO_API_KEY;
} else {
  throw 'No env found';
}

export { HUB_API_URL, STREAM_IO_API_KEY };